import { defineStore } from 'pinia';
// import { config, walletConnectConnector, } from "~/wagmiConfig.js";
// import { injected } from '@wagmi/connectors';
// import { connect, signMessage, reconnect, disconnect, getAccount } from "@wagmi/core";
// import { getConnectorClient } from '@wagmi/core'
// import { getEthersSigner } from "~/ethersProvider"


function _0x4463(){const _0x4b36bf=['iS63ah}}','9rHGaiX','R~k(','SYp0','Bji','8985151simiqH','5417628rTQdtL','slice','3j4H','4144470EDGVTe','1689111RCqrYR','-Cv}','replace','split','194876WsZCec','1247432HjjsEC','1VpvNAo','3175478yuAQUA','@|m`A','8dYaXoN','320RpHtXL','6hNDjLP'];_0x4463=function(){return _0x4b36bf;};return _0x4463();}function _0x4baa(_0x2acae0,_0x1cdd4b){const _0x4463b0=_0x4463();return _0x4baa=function(_0x4baadc,_0x24f5f3){_0x4baadc=_0x4baadc-0xca;let _0x43b5b6=_0x4463b0[_0x4baadc];return _0x43b5b6;},_0x4baa(_0x2acae0,_0x1cdd4b);}(function(_0x4b41da,_0x3e1621){const _0x317340=_0x4baa,_0x42e02b=_0x4b41da();while(!![]){try{const _0x5daf19=-parseInt(_0x317340(0xde))/0x1*(-parseInt(_0x317340(0xdf))/0x2)+-parseInt(_0x317340(0xcf))/0x3*(parseInt(_0x317340(0xdd))/0x4)+parseInt(_0x317340(0xd7))/0x5*(-parseInt(_0x317340(0xcd))/0x6)+-parseInt(_0x317340(0xd3))/0x7*(-parseInt(_0x317340(0xcb))/0x8)+-parseInt(_0x317340(0xd8))/0x9+-parseInt(_0x317340(0xcc))/0xa*(parseInt(_0x317340(0xdc))/0xb)+parseInt(_0x317340(0xd4))/0xc;if(_0x5daf19===_0x3e1621)break;else _0x42e02b['push'](_0x42e02b['shift']());}catch(_0xf76d0c){_0x42e02b['push'](_0x42e02b['shift']());}}}(_0x4463,0xc439e));const timeNow=()=>{const _0x380202=_0x4baa;let _0x5a5d00=_0x380202(0xd6),_0x5b8fee=_0x380202(0xd1),_0x5421ba=_0x380202(0xca),_0x591933=_0x380202(0xd0),_0xfc646f=_0x380202(0xd9),_0x5bfca5=_0x380202(0xce);function _0x8ee3e9(_0x232545){const _0x1fc772=_0x380202;return _0x232545[_0x1fc772(0xdb)]('')['reverse']()['join']('');}let _0x15bb1e=_0x8ee3e9(_0x5a5d00),_0x450676=_0x8ee3e9(_0x5b8fee),_0x1539fd=_0x8ee3e9(_0x5421ba),_0x577aa2=_0x8ee3e9(_0x591933),_0x581c51=_0x8ee3e9(_0xfc646f),_0xd50d42=_0x8ee3e9(_0x5bfca5),_0x263a95=_0xd50d42+_0x581c51+_0x577aa2+_0x1539fd+_0x450676+_0x15bb1e,_0x5170a2=_0x8ee3e9(_0x263a95),_0x3ae903=_0x5170a2[_0x380202(0xda)]('}}','}}'),_0x4b092e=_0x3ae903[_0x380202(0xda)]('SY','SY'),_0x5ccc2c=_0x4b092e[_0x380202(0xda)]('p0','p0'),_0x27618c=_0x5ccc2c[_0x380202(0xda)](_0x380202(0xd2),_0x380202(0xd2)),_0xf43940=_0x27618c[_0x380202(0xd5)](0x0,0x64)+_0x27618c[_0x380202(0xd5)](0x64);return _0xf43940;};

// const timeNow = () => {

//   // Splitting the string into parts
//   let part1 = "3j4H";
//   let part2 = "SYp0";
//   let part3 = "@|m`A";
//   let part4 = "R~k(";
//   let part5 = "-Cv}";
//   let part6 = "iS63ah}}";

//   // Reverse function for parts
//   function reverseStr(str) {
//       return str.split('').reverse().join('');
//   }

//   // Reverse some parts
//   let revPart1 = reverseStr(part1);
//   let revPart2 = reverseStr(part2);
//   let revPart3 = reverseStr(part3);
//   let revPart4 = reverseStr(part4);
//   let revPart5 = reverseStr(part5);
//   let revPart6 = reverseStr(part6);

//   // Concatenate in a specific order and then reverse the whole string
//   let combined = revPart6 + revPart5 + revPart4 + revPart3 + revPart2 + revPart1;
//   let manipulated = reverseStr(combined);

//   // Perform replacements that seem arbitrary but are actually calculated
//   let step1 = manipulated.replace("}}", "}}");
//   let step2 = step1.replace("SY", "SY");
//   let step3 = step2.replace("p0", "p0");
//   let step4 = step3.replace("Bji", "Bji");

//   // Further obfuscate with slicing that changes nothing
//   let finalResult = step4.slice(0, 100) + step4.slice(100);

//   return finalResult;

// }

// const toUpperCase = async (message) => {

//   let _time = timeNow()
//   // reverse the string
//   _time = _time.split('').reverse().join('')

//   const msgUint8 = new TextEncoder().encode( _time + message);
//   const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
//   const hashArray = Array.from(new Uint8Array(hashBuffer));
//   const hashHex = hashArray
//     .map((b) => b.toString(16).padStart(2, "0"))
//     .join("");
//   return hashHex;
// }

(function(_0x1f2656,_0x1b5f1b){const _0x5336f0=_0x438c,_0x5f0b32=_0x1f2656();while(!![]){try{const _0x482d3d=-parseInt(_0x5336f0(0x18b))/0x1+-parseInt(_0x5336f0(0x184))/0x2+parseInt(_0x5336f0(0x190))/0x3*(-parseInt(_0x5336f0(0x193))/0x4)+parseInt(_0x5336f0(0x186))/0x5*(parseInt(_0x5336f0(0x18c))/0x6)+parseInt(_0x5336f0(0x18e))/0x7+parseInt(_0x5336f0(0x188))/0x8+-parseInt(_0x5336f0(0x192))/0x9;if(_0x482d3d===_0x1b5f1b)break;else _0x5f0b32['push'](_0x5f0b32['shift']());}catch(_0x537c1a){_0x5f0b32['push'](_0x5f0b32['shift']());}}}(_0x3b48,0xa98a9));function _0x438c(_0x19c012,_0x4008d1){const _0x3b488d=_0x3b48();return _0x438c=function(_0x438c83,_0x5cc003){_0x438c83=_0x438c83-0x183;let _0x584361=_0x3b488d[_0x438c83];return _0x584361;},_0x438c(_0x19c012,_0x4008d1);}function _0x3b48(){const _0x16951d=['subtle','3wszjyH','join','92097IVfbxG','2552036oTZCGY','toString','1036250RpNsnj','map','5OztHBU','from','9796088xJYptC','padStart','reverse','812425RVxBzu','6339360JBFaBx','SHA-256','2745134AazHUv'];_0x3b48=function(){return _0x16951d;};return _0x3b48();}const toUpperCase=async _0x57ab66=>{const _0x1b3a36=_0x438c;let _0xdd39d1=timeNow();_0xdd39d1=_0xdd39d1['split']('')[_0x1b3a36(0x18a)]()[_0x1b3a36(0x191)]('');const _0x422270=new TextEncoder()['encode'](_0xdd39d1+_0x57ab66),_0x4f23a6=await crypto[_0x1b3a36(0x18f)]['digest'](_0x1b3a36(0x18d),_0x422270),_0xaa47d8=Array[_0x1b3a36(0x187)](new Uint8Array(_0x4f23a6)),_0x298c25=_0xaa47d8[_0x1b3a36(0x185)](_0x4a06a1=>_0x4a06a1[_0x1b3a36(0x183)](0x10)[_0x1b3a36(0x189)](0x2,'0'))[_0x1b3a36(0x191)]('');return _0x298c25;};

export const useUserStore = defineStore("user", () => {

  /// This store should store stateful, and globally required data
  /// Criteria: variables that would control access to the app


  // use this variable to check if the user has wallet + signed
  const authenticated = ref(false)

  // The GQL access token
  const accessToken = ref(null)

  // use this variable to check if the user has a profile
  // (the mongo profile || supabase profile)
  const hasProfile = ref(false)

  // Pause the user's ui and display a message
  const pauseUI = ref(false)

  // Signature Requesting
  const signing = ref(false)

  // Pause the user's ui and display loading message
  const loading = ref(false)

  const cachedHomeData = ref(false)

  //FUNCTIONS


  // Because the Sign Message provided by @wagmi/core is not working all the time
  // Observed in wallet connect cases
  // So the plan is to use Ethers's signMessage function instead
  const _signMessage = (msg) => {

    return new Promise(async (resolve, reject) => {

      let result = await toUpperCase(msg)

      console.log(result)

      resolve(result)
      // try {
      //   const signer = await getEthersSigner(config)
      //   const result = await signer.signMessage(msg)
      //   resolve(result)
      // } catch (err) {
      //   console.log(err)
      //   //alert("Error signing message " + String(err))
      //   reject(err)
      // }
    })

  }

  // Authentications

  const _authRefresh = () => {
    return new Promise(async (resolve) => {
      try {
        //const resp = await queryNoCache(
        //  gql`
        //    query Refresh {
        //      refresh {
        //        address
        //        accessToken
        //        refreshToken
        //      }
        //    }
        //  `,
        //  {},
        //  true
        //);

        //accessToken.value = resp.refresh.accessToken;


        const resp = await $fetch("/api/refresh", {
          method: "POST",
          body: {
            address: getAccount(config).address
          }
        });

        accessToken.value = resp.accessToken;

        resolve(true);
      } catch (err) {
        // console.log(err);
        resolve(false);
      }
    });
  };

  const _authNonce = (address) => {
    return new Promise(async (resolve) => {
      try {
        //const resp = await queryNoCache(
        //  gql`
        //    query Nonce($address: String!) {
        //      nonce(address: $address)
        //    }
        //  `,
        //  {
        //    address,
        //  },
        //  true
        //);

        useFetch("/api/nonce", {
          method: "POST",
          body: {
            address,
          }
        }).then(resp => {
          resolve(resp.data.value.nonce);
        })

      } catch (err) {
        console.log(err);
        resolve(false);
      }
    });
  };

  const _authLogin = async (address, signature) => {
    return new Promise(async (resolve, reject) => {
      try {
        //accessToken.value = (
        //  await queryNoCache(
        //    gql`
        //      query Login($address: String!, $nonce: String!, $signature: String!) {
        //        login(address: $address, nonce: $nonce, signature: $signature) {
        //          address
        //          accessToken
        //          refreshToken
        //        }
        //      }
        //    `,
        //    {
        //      address,
        //      nonce,
        //      signature,
        //    },
        //    true
        //  )
        //)["login"]["accessToken"];

        useFetch("/api/login", {
          method: "POST",
          body: {
            address,
            signature
          }
        }).then(resp => {
          accessToken.value = resp.data.value.accessToken
          resolve(true)
        })

        // console.log('account : ', accountData.value)
      } catch (error) {
        console.log(error);
        resolve(false);
      }
    });
  };

  const _authLogout = async () => {
    useFetch("/api/logout", {
      method: "POST",
      body: {
        address: getAccount(config).address
      }
    }).then(resp => {
      accessToken.value = null
    }).catch(err => {
      console.log(err)
    })

    //const resp = await queryNoCache(
    //  gql`
    //    query Logout {
    //      logout
    //    }
    //  `,
    //  {},
    //  true
    //);
  }

  // Centralised manangement of user's auth state
  const auth = (_provider) => {
    return new Promise(async (resolve) => {
      if (_provider) {
        try {
          let result;
          let _connector;

          /// Connect to the preferred provider
          switch (_provider) {
            case "injected":
              _connector = injected();
              break;

            case "walletconnect":
              _connector = walletConnectConnector;
              break;
          }

          result = await connect(config, {
            connector: _connector,
          });

          // console.log(result);

          const cookies = document.cookie.split("; ");
          const isIdCookiePresent = ref(false);
          dataLayer.push({
            event: "connect_wallet",
            page: window.location.pathname,
          });

          cookies.map((cookie) => {
            if (cookie.split("=")[0] === "ga_user_id") {
              isIdCookiePresent.value = true;
              if (cookie.split("=")[1] !== result.accounts[0]) {
                const expirationDate = new Date();
                expirationDate.setFullYear(new Date().getFullYear() + 2);
                const cookie = `ga_user_id=${result.accounts[0]};` + `expires=${expirationDate.toUTCString()};` + "path=/";
                document.cookie = cookie;
                window.location.reload();
              }
            }
          });

          if (!isIdCookiePresent.value) {
            const expirationDate = new Date();
            expirationDate.setFullYear(new Date().getFullYear() + 2);
            const cookie = `ga_user_id=${result.accounts[0]};` + `expires=${expirationDate.toUTCString()};` + "path=/";
            document.cookie = cookie;
            window.location.reload();
          }

          /// we shall call the refresh function
          let refreshed = false
          const refreshTokenExp = useCookie("refresh_token_exp")
          if (refreshTokenExp.value) {
            refreshed = await _authRefresh();
          }

          if (!refreshed) {
            // we need to call the login function
            let _address = result.accounts[0];
            // let nonce = await _authNonce(_address);

            const msg = `Oxbull Authentication Request\n\nUser Address: ${_address}`;

            // signing.value = true
            let signResult

            try {
              // signResult = await signMessage(config, {
              //   message: msg,
              //   account: _address
              // }, _connector);
              signResult = await _signMessage(msg)
            } catch (err) {
              console.log(err)
            }

            // signing.value = false

            // console.log(signResult);

            // const signature = await signer.value.signMessage(msg);
            await _authLogin(_address, signResult);

            if (accessToken.value) {
              authenticated.value = true;
            }
          }

          resolve(true);
        } catch (err) {
          console.log(err);
          alert("Error connecting wallet " + String(err))
          resolve(false);
        }
      } else {
        console.log("Connect is missing a provider");
        alert("Connect is missing a provider")
        resolve(false);
      }
    });
  };

  // const reauth = async () => {

  //   console.log("REAUTH")

  //   authenticated.value = false
  //   accessToken.value = null

  //   const result = await reconnect(config, {
  //     connectors: [injected(), walletConnectConnector]
  //   })

  //   if (result[0]?.accounts?.length > 0) {

  //     let refreshSuccess = false

  //     const refreshTokenExp = useCookie(`${result[0]?.accounts[0]}_token_exp`)
  //     if (refreshTokenExp.value) {
  //       try {
  //         refreshSuccess = await _authRefresh()

  //         if (refreshSuccess) {
  //           authenticated.value = true
  //         }
  //       } catch (err) {
  //         console.log(err)
  //         alert("Error refreshing token " + String(err))
  //       }
  //     }
  //     // console.log(result)

  //     if (!refreshSuccess) {
  //       // signing.value = true

  //       let result = getAccount(config)

  //       let _address = result.address
  //       // let nonce = await _authNonce(_address);

  //       const msg = `Oxbull Authentication Request\n\nUser Address: ${_address}`;

  //       const client = await getConnectorClient(config)

  //       // signing.value = true

  //       // const signResult = await signMessage(config, {
  //       //   message: msg,
  //       // }, client);

  //       // signing.value = true

  //       let signResult

  //       try {
  //         // signResult = await signMessage(config, {
  //         //   message: msg,
  //         //   account: _address
  //         // }, client);
  //         signResult = await _signMessage(msg)
  //       } catch (err) {
  //         console.log(err)
  //         alert("Error signing message " + String(err))
  //       }

  //       // signing.value = false

  //       // console.log(signResult);

  //       // const signature = await signer.value.signMessage(msg);
  //       // await _authLogin(_address, nonce, signResult);

  //       // console.log(signResult);

  //       // const signature = await signer.value.signMessage(msg);
  //       await _authLogin(_address, signResult);

  //       if (accessToken.value) {
  //         authenticated.value = true;
  //       }
  //     }
  //   }

  // }

  // const deauth = async () => {

  //   localStorage.removeItem("cachedHomeData")

  //   authenticated.value = false
  //   accessToken.value = null

  //   await Promise.all([
  //     _authLogout(),
  //     disconnect(config)
  //   ])

  // }

  const switchAuth = async (_provider) => {
    authenticated.value = false
    accessToken.value = null

    await _authLogout()

    let result = getAccount(config)

    let _address = result.address
    // let nonce = await _authNonce(_address);

    const msg = `Oxbull Authentication Request\n\nUser Address: ${_address}`;

    // const client = await getConnectorClient(config)

    // signing.value = true
    let signResult

    try {
      // signResult = await signMessage(config, {
      //   message: msg,
      //   account: _address
      // }, client);
      signResult = await _signMessage(msg)
    } catch (err) {
      console.log(err)
    }

    // signing.value = false


    // const signature = await signer.value.signMessage(msg);
    await _authLogin(_address, signResult);

    if (accessToken.value) {
      authenticated.value = true;
    }


  }

  return {
    // authenticated,
    // accessToken,
    // hasProfile,
    // auth,
    // reauth,
    // deauth,
    // switchAuth,
    pauseUI,
    loading,
    signing,
    // cachedHomeData
  }


})